import React from 'react';
import { useMediaQuery } from 'react-responsive';
import WebBuilderContent from './WebBuilderContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <WebBuilderContent history={history} />
  </Mobile>
);

export default MobileResponsive;
